<app-menu [menuModuleEnum]='menuModuleEnum' [menuFunctionalityEnum]='menuFunctionalityEnum'></app-menu>

<div class="container-body">
    <h1>Grupo de Medicamento</h1>
    <div class="white-body">
        <div class="row">
            <div class="col-12 col-md-6">
                <a mat-button class="btn-primary add-user" routerLink="/consulting/template-group/register"><mat-icon aria-hidden="false" aria-label="Plus">add</mat-icon> Cadastrar Grupo de Medicamento</a>
            </div>
        </div>
        <div class="filters">
            <div class="row">   
                <div class="col-12 col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-icon matPrefix class="my-icon">search</mat-icon>
                        <mat-label>Pesquisar</mat-label>
                        <input matInput type="text" id="searchText" name="searchText" [(ngModel)]="searchText" (keyup)="onKeySearch($event)">
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Template</mat-label>
                        <mat-select [(ngModel)]="idTemplate" (selectionChange)="search()">
                            <mat-option value="">
                                Todos
                            </mat-option>
                            <mat-option *ngFor="let item of listTemplate" value="{{item.idTemplate}}">
                                {{item.templateName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>           
            </div>
        </div>
        <div class="card-list" *ngIf="listMedicineGroup != null">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4" *ngFor="let item of listMedicineGroup">
                    <div class="card-item">
                        <div class="infos">
                            <span class="primary">{{item.medicineGroupName}}</span>
                            <span class="secundary">{{item.medicineGroupDescription}}</span>
                            <span class="secundary">{{item.medicineTypeName}}</span>
                            <span class="secundary">{{item.templateName}}</span>
                        </div>
                        <div class="actions">
                            <a><mat-icon aria-hidden="false" aria-label="Editar" [routerLink] = "['/consulting/template-group/register', {idMedicineGroup: item.idMedicineGroup}]">edit</mat-icon> </a>
                            <a><mat-icon aria-hidden="false" aria-label="Editar" (click)="openModal(item.idMedicineGroup)">delete_forever</mat-icon> </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-empty-list *ngIf="listMedicineGroup != undefined && listMedicineGroup.length == 0"></app-empty-list>
    </div>

    <app-loading-list *ngIf="isLoading"></app-loading-list>
</div>